<template lang="html">
    <loader v-if="loading">Rooster wordt aangemaakt...</loader>
    <div v-else class="rooster d-flex flex-row">
        <main class="flex-grow-1 rooster" id="selecto-container">
            <b-row class="week sticky-top" no-gutters>
                <b-col class="week-col">
                    <grid-cell title="Week" />
                </b-col>
                <b-col class="psalm-col">
                    <grid-cell title="Maandag" />
                </b-col>
                <b-col>
                    <grid-cell title="Dinsdag" />
                </b-col>
                <b-col>
                    <grid-cell title="Woensdag" />
                </b-col>
                <b-col>
                    <grid-cell title="Donderdag" />
                </b-col>
                <b-col>
                    <grid-cell title="Vrijdag" />
                </b-col>
            </b-row>
            <b-row v-for="(week, wi) in cluster.data" :key="`week-${wi}`" class="week" no-gutters>
                <b-col class="week-col">
                    <grid-cell :title="`Week ${week.index}`" />
                </b-col>
                <b-col v-for="(day, di) in week.days"
                       :key="`day-${di}`"
                       class="selectable"
                       :class="{ 'psalm-col': di === 0 }">
                    <grid-cell
                        :date.sync="day.localDate"
                        :title.sync="day.localTitle"
                        :titles.sync="day.localTitles"
                        :description.sync="day.localDescription"
                        :backgroundColor.sync="day.localBackgroundColor"
                        :textColor.sync="day.localTextColor"
                        :data.sync="day.localData"
                        :day.sync="day"
                        ref="grid"
                    />
                </b-col>
            </b-row>

            <vue-selecto
                :selectableTargets="['.selectable']"
                :dragContainer="dragContainer"
                :hitRate="5"
                :selectFromInside="true"
                :selectByClick="true"
                :toggleContinueSelect="'shift'"
                @select="onSelect"
                @selectStart="onSelectStart"
                @selectEnd="onSelectEnd"
            />
        </main>

        <sidebar :selection="selected" :settings="sideBarSettings"/>
    </div>
</template>

<script>
import GridCell from '../components/GridCell';
import Sidebar from '../components/Sidebar';
import { VueSelecto } from 'vue-selecto';
import Week from '../modules/week.module';
import Day from '../modules/day.module';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import SidebarModule from '../modules/sidebar.module'

export default {
    name: 'Rooster',
    data() {
        return {
            loading: true,
            dragContainer: document.querySelector('#selecto-container'),
            selected: [],
            clusters: [
                {
                    name: 'Cluster 1',
                    value: 'cluster_1',
                    data: [],
                },
                {
                    name: 'Cluster 2',
                    value: 'cluster_2',
                    data: [],
                },
                {
                    name: 'Cluster 3',
                    value: 'cluster_3',
                    data: [],
                },
            ],
            clusterIndex: 0,
            sideBarSettings: SidebarModule,
        };
    },
    computed: {
        cluster() {
            return this.clusters.find((c) => {
                return c.value === this.sideBarSettings.global.cluster;
            });
        },
        ...mapGetters([
            'rooster/schooljaar',
            'rooster/cache',
        ])
    },
    mounted() {
        // Set timeout, else loading wont show because vue is busy processing rooster
        setTimeout(() => {
            this.initRooster();
        }, 100);
    },
    methods: {
        async initRooster() {
            this['rooster/resetLessonIndex']();
            this['rooster/initClusters']();

            if (this['rooster/cache'] !== null) {
                let c = 0;
                this['rooster/cache'].forEach((cluster) => {
                    cluster.data.map((week) => {
                        const days = [];
                        for (let i = 0; i<week.days.length; i++) {
                            const day = new Day('');
                            day.load(week.days[i]);
                            day.localDate = this.moment(day.localDate)
                            days.push(day);
                        }
                        this.clusters[c].data.push(new Week(days, cluster.value));
                    });
                    c++;
                });
            } else {
                const schooljaar = this['rooster/schooljaar'];
                const momentRange = this.moment.range(
                    this.moment(schooljaar.from).startOf('week'),
                    this.moment(schooljaar.to).endOf('week')
                ).by('days');
                const range = Array.from(momentRange);
                await this['rooster/fetchHoliday']();

                this.clusters.forEach((cluster) => {
                    cluster.data = this._.chunk(
                        range.filter((date) => {
                            return date.isoWeekday() <= 5;
                        }).map((date) => new Day(date)),
                        5,
                    ).map((days) => new Week(days, cluster.value));
                });
            }
            this.$watch('clusters', this.saveClusters, { deep: true });

            this.$nextTick(() => {
                this.loading = false;
            })
        },
        onSelect(e) {
            e.added.forEach((el) => el.classList.add('selecting'));
            e.removed.forEach((el) => el.classList.remove('selecting'));
        },
        onSelectStart(e) {
            this.sideBarSettings.reset();

            e.added.forEach((el) => el.classList.add('selected'));
            e.removed.forEach((el) => el.classList.remove('selected'));
        },
        onSelectEnd(e) {
            e.afterAdded.forEach((el) => el.classList.add('selected'));
            e.afterRemoved.forEach((el) => el.classList.remove('selected'));

            this.selected = this.$refs.grid.filter((component) => e.selected.includes(component.$el.parentElement));

            this.$root.$emit('parse:selection', this.selected);
        },
        saveClusters() {
            this.$nextTick(() => {
                this['rooster/SET_CACHE'](this.clusters);
            });
        },
        ...mapActions([
            'rooster/fetchHoliday',
            'rooster/resetLessonIndex',
            'rooster/initClusters',
        ]),
        ...mapMutations([
            'rooster/SET_CACHE',
        ]),
    },
    components: {
        GridCell,
        Sidebar,
        VueSelecto,
    },
};
</script>
